import { go, Model } from 'oderon-vue'

export const CostCenter = new Model('/cost-centers')

CostCenter.getReport = (ps) =>
  go.get(`cost-centers/${ps.costCenterId}/report`, ps)

CostCenter.downloadReport = (ps) =>
  go.download(`cost-centers/${ps.costCenterId}/report/download`, ps)

CostCenter.downloadMultipleReports = (ps) =>
  go.download(`cost-centers/multiple-reports/download`, ps)

CostCenter.getGrid = (ps) => go.get('cost-centers/grid', ps)
CostCenter.getGridSpec = (ps) => go.get('cost-centers/grid/spec', ps)
CostCenter.downloadGrid = (ps) => go.download('/cost-centers/grid/download', ps)

CostCenter.reactivate = function(costCenterId) {
  if (costCenterId == null) throw new Error('Missing costCenterId')
  return go.post(`/cost-centers/${costCenterId}/reactivate`)
}

CostCenter.getMultiproductMeasureTotal = function({
  costCenterId,
  month,
  fromDate,
  untilDate
}) {
  if (costCenterId == null) throw new Error('Missing costCenterId')
  return go.get(`/multiproduct/cost-center/total`, {
    costCenterIds: costCenterId,
    month,
    fromDate,
    untilDate
  })
}
